import { reportEvents } from "@/config/reporting.config";

/**
 * 进入官网
 */
export const homeOnShowReporting = () => {
  reportEvents("web_enter", {});
};

// 进入概念站
export const homeOnOfficialSiteClickReporting = () => {
  reportEvents("worldweb_enter", {});
};

// 点击点击适龄提示
export const homeOnAgeTipsClickReporting = () => {
  reportEvents("age_appropriate", {});
};

//点击选择登录渠道 1微信,2QQ
export const clickLogin = (s_login_channel) => {
  reportEvents("login_step", { s_login_channel });
};

// 完成登录
export const homeOnOfficialMediaCompleteReporting = (s_login_channel) => {
  reportEvents("login_finish", { s_login_channel });
};

// 点击立即预约
export const homeOnOfficialMediaAppointClickReporting = () => {
  reportEvents("booking_step1", {});
};

// 提交预约
export const homeOnOfficialMediaAppointCompleteReporting = () => {
  reportEvents("booking_step2", {});
};

// 预约成功
export const homeOnOfficialMediaAppointSuccessReporting = () => {
  reportEvents("booking_finish", {});
};

// 点击进入新闻详情页
export const homeOnOfficialNewsClickReporting = (s_news_id) => {
  reportEvents("goto_news", { s_news_id });
};

/**
 * 点击官媒
 * @param s_share_plat 1微信、2微博、3Tap、 4B站、5QQ
 */
export const homeOnOfficialMediaClickReporting = (s_share_plat) => {
  reportEvents("official_media", {
    s_share_plat,
  });
};

// 点击播放pv
export const homeOnPlayClickReporting = () => {
  reportEvents("pv_play");
};

// 点击地图
export const homeOnMapClickReporting = (s_map_id) => {
  reportEvents("look_map", { s_map_id });
};

// 点击角色 1帕塔,2恩洛尔,3安娜塔,4金羊毛,5影犬,6莫伊莱
export const homeOnRoleClickReporting = (s_role_id) => {
  reportEvents("look_role", { s_role_id });
};
